import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=6cf56fed&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports